<template>
  <section class="receipt-form">
    <h3>{{ kind === 'wechat' ? '微信收款信息' : '支付宝收款信息' }}</h3>
    <template v-if="saved && !editable">
      <van-cell title="收款人姓名" :value="saved.name" />
      <van-image v-if="saved.qr_code" width="160" height="160" fit="contain" :src="saved.qr_code" @click="preview(saved.qr_code)" />
      <p class="receipt-tip">已填写，修改请联系管理员</p>
    </template>
    <template v-else>
      <van-field v-model.trim="draft.name" label="收款人姓名" maxlength="64" placeholder="请输入真实收款姓名" />
      <div class="receipt-upload">
        <van-image v-if="draft.qr_code" width="140" height="140" fit="contain" :src="draft.qr_code" @click="preview(draft.qr_code)" />
        <van-uploader accept="image/png,image/jpeg" :after-read="upload" :max-count="1">
          <van-button size="small" icon="photograph">{{ draft.qr_code ? '重新选择收款码' : '上传收款码' }}</van-button>
        </van-uploader>
        <van-button v-if="draft.qr_code" size="small" type="default" @click="draft.qr_code = ''">移除未提交图片</van-button>
      </div>
      <p class="receipt-tip">{{ kind === 'wechat' ? '微信必须上传收款码。' : '支付宝仅支持收款二维码。' }}图片支持1MB以内的PNG、JPG；审核通过后仅管理员可修改。</p>
    </template>
  </section>
</template>
<script>
import { ImagePreview } from 'vant';
import { readReceiptImage } from '@/api-service/receipt';
export default {
  props: { kind: { type: String, required: true }, saved: { type: Object, default: null }, editable: { type: Boolean, default: false } },
  data() { return { draft: { name: '', account: '', qr_code: '' } }; },
  watch: {
    saved: {
      immediate: true,
      handler(value) { this.draft = { name: '', account: '', qr_code: '', ...(value || {}) }; if (this.kind === 'alipay') this.draft.account = ''; }
    }
  },
  methods: {
    async upload(item) { try { this.draft.qr_code = await readReceiptImage(item.file); } catch (e) { this.$toast.fail(e.message); } },
    preview(src) { ImagePreview([src]); },
    value() {
      if (this.saved && !this.editable) return null;
      const d = this.draft;
      if (!d.name && !d.account && !d.qr_code) return null;
      if (!d.name) throw new Error('请填写收款人姓名');
      if (this.kind === 'wechat' && !d.qr_code) throw new Error('请上传微信收款码');
      if (this.kind === 'alipay' && !d.qr_code) throw new Error('请上传支付宝收款码');
      return { ...d, account: '', kind: this.kind };
    }
  }
};
</script>
<style scoped>
.receipt-form { margin: 12px 0; padding: 12px; background: white; border-radius: 10px; }
.receipt-form h3 { font-size: 16px; margin: 4px 0 12px; }
.receipt-tip { color: #888; font-size: 12px; line-height: 1.7; }
.receipt-upload { display: flex; gap: 10px; flex-wrap: wrap; align-items: center; padding: 12px 0; }
</style>
